import { Influencer } from '@core/models/ApiFields/ig-field-values.types';

export class PostUser {
    constructor(
        public image: string,
        public username: string,
        public influencer: Influencer,
        public level: number,
        public likes: number,
        public commentsCount: number
    ) {}
}
